import React from "react";
import { TableBody } from "@mui/material";
import { ParentProps } from "../../types";

const classNameBase = "scd-table-light-body";

export default function BodyTableLight(props: ParentProps): React.JSX.Element {
  const { children } = props;

  return (
    <TableBody
      classes={{
        root: `${classNameBase}-root`,
      }}
    >
      {children}
    </TableBody>
  );
}
